import { isEqual } from 'lodash';

import React, { useCallback, useState, useEffect } from 'react';

// Project components (adjust the paths as needed)
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';

// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// _mock
import { _roles } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Card from '@mui/material/Card';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { useSettingsContext } from 'src/components/settings';
import {
  useTable,
  getComparator,
  emptyRows,
  TableNoData,
  TableEmptyRows,
  TableHeadCustom,
  TableSelectedAction,
  TablePaginationCustom,
} from 'src/components/table';
//
import { endpoints, getFetcher1, postPramsFetcher1 } from 'src/utils/axios';
import TourGuideTableRow from './tour-guide-table-row';
import TourGuideTableFiltersResult from './tour-guide-table-filters-result';
import TourGuideAsignSchemaTableRow from './tour-guide-asign-schema-table-row';
import TourGuideItemSchemaTableToolbar from './tour-guide-item-schema-table-toolbar';

export default function TourGuideAsignListUI({
  tableLoading,
  handlePageChange,
  handleSizeChange,
  tableDataFromParent,
  handleEditRowParent,
  handleEditRowEnable,
  loading,
  setNameFromChild,
  setToolbarSchemaIdFromChild,
}) {
  const table = useTable();

  const router = useRouter();

  const confirm = useBoolean();

  const defaultFilters = React.useMemo(
    () => ({
      id: 0,
      name: '',
      company: '',
      payment: '',
      incoterms: '',
      startDate: '',
      endDate: '',
      role: [],
      status: 'all',
    }),
    []
  );
  console.log('tableDataFromParent1', tableDataFromParent);

  const [tableData, setTableData] = useState(
    tableDataFromParent?.content === null ? [] : tableDataFromParent?.content || []
  );
  const [filters, setFilters] = useState(defaultFilters);
  const [rowsPerPage, setRowsPerPages] = useState(tableDataFromParent?.pageable?.pageSize || 10);
  const [totalDataSize, setTotalDataSize] = useState(tableDataFromParent?.totalElements || 0);
  const [pageNum, setPageNum] = useState(tableDataFromParent?.pageable?.pageNumber || 0);
  const [serachByCodeParent, setSerachByCodeParent] = useState(null);
  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator('desc', table.orderBy),
    filters,
  });
  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );
  const canReset = !isEqual(defaultFilters, filters);
  console.log('tableData111', tableData);

  useEffect(() => {
    if (serachByCodeParent) {
      setNameFromChild(serachByCodeParent);
    }
  }, [serachByCodeParent, setNameFromChild]);

  const TABLE_HEAD = [
    { id: 'id', label: 'Id' },
    { id: 'schemaname', label: 'Schema Name' },
    { id: 'supplierName', label: 'Supplier Name' },
    { id: 'isEnable', label: 'Enable', width: 180 },
    { id: 'action', label: 'Action', width: 180 },
  ];

  useEffect(() => {
    // if (tableDataFromParent) {
    setTableData(tableDataFromParent?.content || []);
    setTotalDataSize(tableDataFromParent?.totalElements || 0);
    setPageNum(tableDataFromParent?.pageable?.pageNumber || 0);
    setRowsPerPages(tableDataFromParent?.pageable?.pageSize || 10);
    // }
  }, [tableDataFromParent, defaultFilters]);

  const handleResetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, [defaultFilters]);

  const handleFilters = useCallback(
    (name, value) => {
      table.onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [table]
  );

  const denseHeight = table.dense ? 52 : 72;

  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

  const setToolbarSchemaIdFromChild1 = useCallback(
    (id, name, supplier) => {
      setToolbarSchemaIdFromChild(id, name, supplier);
    },
    [setToolbarSchemaIdFromChild]
  );

  // Call handlePageChange and handleSizeChange when pageNum or rowsPerPage changes
  useEffect(() => {
    if (typeof handlePageChange === 'function') {
      handlePageChange(pageNum);
    }
  }, [pageNum, handlePageChange]);

  useEffect(() => {
    if (typeof handleSizeChange === 'function') {
      handleSizeChange(rowsPerPage);
    }
  }, [rowsPerPage, handleSizeChange]);

  const handleRowsPerPageChange = (event) => {
    const selectedPageSize = event.target.value;
    setRowsPerPages(selectedPageSize);
    setPageNum(0);
  };
  const onEditRowEnable = (row, isEnabled) => {
    handleEditRowEnable(row, isEnabled);
  };

  const handleViewRow = useCallback(
    (id) => {
      router.push(paths.dashboard.vendor.profile(id));
    },
    [router]
  );

  const handleChangePage = (event, newPage) => {
    setPageNum(newPage);
  };

  return (
    <Card>
      <TourGuideItemSchemaTableToolbar
        filters={filters}
        onFilters={handleFilters}
        //
        setToolbarSchemaIdFromChild={setToolbarSchemaIdFromChild1}
        roleOptions={_roles}
        setSerachByCodeParent={setSerachByCodeParent}
        serachByCodeParent={serachByCodeParent}
      />

      {canReset && (
        <TourGuideTableFiltersResult
          filters={filters}
          onFilters={handleFilters}
          //
          onResetFilters={handleResetFilters}
          //
          results={dataFiltered.length}
          sx={{ p: 2.5, pt: 0 }}
        />
      )}

      <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Spinner */}
            <span>
              <CircularProgress color="primary" size={40} thickness={4} />
            </span>
          </div>
        )}
        <TableSelectedAction
          dense={table.dense}
          numSelected={table.selected.length}
          rowCount={tableData.length}
          onSelectAllRows={(checked) =>
            table.onSelectAllRows(
              checked,
              tableData.map((row) => row.id)
            )
          }
          action={
            <Tooltip title="Delete">
              <IconButton color="primary" onClick={confirm.onTrue}>
                <Iconify icon="solar:trash-bin-trash-bold" />
              </IconButton>
            </Tooltip>
          }
        />

        <Scrollbar>
          <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
            <TableHeadCustom
              headLabel={TABLE_HEAD}
              rowCount={tableData.length}
              numSelected={table.selected.length}
            />

            <TableBody>
              {dataFiltered.length === 0 ? (
                <tr>
                  <td colSpan={TABLE_HEAD.length} style={{ textAlign: 'center', padding: 32 }}>
                    No data found.
                  </td>
                </tr>
              ) : (
                dataFiltered
                  .slice(table.page * rowsPerPage, table.page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TourGuideAsignSchemaTableRow
                      key={row.id}
                      row={row}
                      onEditRow={handleEditRowParent}
                      onEditRowEnable={onEditRowEnable}
                      onViewRow={() => handleViewRow(row.id)}
                    />
                  ))
              )}

              {tableData.length > 0 && (
                <TableEmptyRows
                  height={denseHeight}
                  emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                />
              )}

              {tableData.length > 0 && <TableNoData notFound={notFound} />}
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>

      <TablePaginationCustom
        count={totalDataSize}
        page={pageNum}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[10, 25, 50, 100, 250, 500]}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* dense and onChangeDense props should be passed to a component, not left outside */}
    </Card>
  );
}

TourGuideAsignListUI.propTypes = {
  handlePageChange: PropTypes.func,
  handleSizeChange: PropTypes.func,
  tableDataFromParent: PropTypes.object,
  tableLoading: PropTypes.object,
  loading: PropTypes.bool,
  handleEditRowParent: PropTypes.func,
  handleEditRowEnable: PropTypes.func,
  setNameFromChild: PropTypes.func,
  setToolbarSchemaIdFromChild: PropTypes.func,
};
function applyFilter({ inputData, comparator, filters }) {
  return inputData;
}
